import { render } from "./PerfilEdit.vue?vue&type=template&id=28846b54&ts=true"
import script from "./PerfilEdit.vue?vue&type=script&lang=ts"
export * from "./PerfilEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__